import {useInboxStatuses} from '../hooks';

const withInboxStatuses = (Component) => {
  return (props) => {
    const statuses = useInboxStatuses();
    return <Component statuses={statuses} {...props}/>;
  }
};

export default withInboxStatuses;
